export default __webpack_public_path__ + "static/media/miguel-lopes-20.3f29b5fe.jpg";